const CryptoJS = require('crypto-js')
export const key = 'adL*1!jf'
export const DESKEY = [97,100,76,42,49,33,106,102]

export function decryptByDESModeCBC(ciphertext2) {
  let decrypted = CryptoJS.DES.decrypt({
    ciphertext: ciphertext2
  }, key, {
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });
  // console.log('CryptoJS.enc.Hex.parse(DESKEY)', CryptoJS.enc.Hex.parse(DESKEY))
  console.log('decrypted', decrypted)
  return decrypted.toString(CryptoJS.enc.Hex);
}


// WEBPACK FOOTER //
// ./src/utils/key.js